<div id="imageHostContainer" class="image-host-container">
    <img [src]="currentImage" (click)="nextImage()" class="img-fluid" />
</div>
